const dev_config = {
  url: 'https://callcenterdev.tripshock.com',
  platformUrl: 'https://staging-my.tripshock.com',
  siteUrl: 'https://staging-front-end.tripshock.com',
  apiUrl: 'https://y0nncpqj0h.execute-api.us-east-1.amazonaws.com/staging/exec',
  apiKey: 'XMbSYX465EMPPgTFBSXG4qONwEVUC3X4RQrOEHgb',
  connectUrl: 'https://tripshockdev.my.connect.aws',
  region: 'us-west-2',
  instanceId: '51563b74-fc4f-4c8e-9e5e-772deeac1156',
};

const prod_config = {
  url: 'https://callcenter.tripshock.com',
  platformUrl: 'https://my.tripshock.com',
  siteUrl: 'https://tripshock.com',
  apiUrl: 'https://88fjt7qdz8.execute-api.us-east-1.amazonaws.com/prod/exec',
  apiKey: 'lt3rV1NrA26wdYLgUFPZm4sjEifNtLSX1y15vZUj',
  connectUrl: 'https://tripshock.my.connect.aws',
  region: 'us-east-1',
  instanceId: '32f1f200-1b30-454a-8f52-0441cbb4d340',
};

export const config =
  process.env.REACT_APP_ENV === 'staging' ? dev_config : prod_config;
